import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
} from '../../../UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../UUID.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { OauthClientf2xy0pwltr7q as OauthClient } from '../oauth/models.mjs';
import {
  References1cc2ge45k8vol as References,
  AdminTableColumns2kd3zhffh08h8 as AdminTableColumns,
} from '../../../lightningdb/Annotations.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../lightningdb/HasId.mjs';
import {
  $serializer_getInstance3v9seicvbql6t as $serializer_getInstance,
  $serializer_getInstancestor8ej9dr0n as $serializer_getInstance_0,
} from '../proof/proofModels.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function Session$Companion$$childSerializers$_anonymous__rup784() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Session$Companion$$childSerializers$_anonymous__rup784_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Session$Companion$$childSerializers$_anonymous__rup784_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Session$Companion$$childSerializers$_anonymous__rup784_2() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Session$Companion$$childSerializers$_anonymous__rup784_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Session$Companion$$childSerializers$_anonymous__rup784_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Session$Companion$$childSerializers$_anonymous__rup784_5() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Session$Companion$$childSerializers$_anonymous__rup784_6() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
function Session$Companion$$childSerializers$_anonymous__rup784_7() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
function Session$Companion$$childSerializers$_anonymous__rup784_8() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Session$Companion$$childSerializers$_anonymous__rup784);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Session$Companion$$childSerializers$_anonymous__rup784_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Session$Companion$$childSerializers$_anonymous__rup784_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, Session$Companion$$childSerializers$_anonymous__rup784_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, Session$Companion$$childSerializers$_anonymous__rup784_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, Session$Companion$$childSerializers$_anonymous__rup784_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, Session$Companion$$childSerializers$_anonymous__rup784_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_15 = lazy(tmp_14, Session$Companion$$childSerializers$_anonymous__rup784_6);
        var tmp_16 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_17 = lazy(tmp_16, Session$Companion$$childSerializers$_anonymous__rup784_7);
        var tmp_18 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.v2y_1 = [tmp_1, null, tmp_3, null, null, tmp_5, tmp_7, tmp_9, tmp_11, tmp_13, tmp_15, tmp_17, lazy(tmp_18, Session$Companion$$childSerializers$_anonymous__rup784_8), null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.subject.Session', null, 14);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('secretHash', false);
        tmp0_serialDesc.a1b('derivedFrom', true);
        tmp0_serialDesc.a1b('label', true);
        tmp0_serialDesc.a1b('subjectId', false);
        tmp0_serialDesc.a1b('createdAt', true);
        tmp0_serialDesc.a1b('lastUsed', true);
        tmp0_serialDesc.a1b('expires', true);
        tmp0_serialDesc.a1b('stale', true);
        tmp0_serialDesc.a1b('terminated', true);
        tmp0_serialDesc.a1b('ips', true);
        tmp0_serialDesc.a1b('userAgents', true);
        tmp0_serialDesc.a1b('scopes', false);
        tmp0_serialDesc.a1b('oauthClient', true);
        this.w2y_1 = tmp0_serialDesc;
      }
      x2y(typeSerial0, typeSerial1) {
        return $serializer().y4j(typeSerial0, typeSerial1);
      }
      f1c(typeParamsSerializers) {
        return this.x2y(typeParamsSerializers[0], typeParamsSerializers[1]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static z4j() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.subject.Session', $this, 14);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('secretHash', false);
        tmp0_serialDesc.a1b('derivedFrom', true);
        tmp0_serialDesc.a1b('label', true);
        tmp0_serialDesc.a1b('subjectId', false);
        tmp0_serialDesc.a1b('createdAt', true);
        tmp0_serialDesc.a1b('lastUsed', true);
        tmp0_serialDesc.a1b('expires', true);
        tmp0_serialDesc.a1b('stale', true);
        tmp0_serialDesc.a1b('terminated', true);
        tmp0_serialDesc.a1b('ips', true);
        tmp0_serialDesc.a1b('userAgents', true);
        tmp0_serialDesc.a1b('scopes', false);
        tmp0_serialDesc.a1b('oauthClient', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(OauthClient())));
        tmp0_serialDesc.c1b(new (AdminTableColumns())(['label', 'subjectId', 'scopes']));
        $this.v4j_1 = tmp0_serialDesc;
        return $this;
      }
      a4k(encoder, value) {
        var tmp0_desc = this.v4j_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().v2y_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.e2z_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.e2z_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.f2z_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.g2z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.g2z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.h2z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.h2z_1);
        }
        tmp1_output.c15(tmp0_desc, 4, this.x4j_1, value.i2z_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).b1m();
          tmp = !value.j2z_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.j2z_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp_0 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$1 = get_default(Companion_instance).b1m();
          tmp_0 = !value.k2z_1.equals(tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.k2z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.l2z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, tmp2_cached[7].f2(), value.l2z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.m2z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, tmp2_cached[8].f2(), value.m2z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.n2z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, tmp2_cached[9].f2(), value.n2z_1);
        }
        var tmp_1;
        if (tmp1_output.h15(tmp0_desc, 10)) {
          tmp_1 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$2 = emptySet();
          tmp_1 = !equals(value.o2z_1, tmp$ret$2);
        }
        if (tmp_1) {
          tmp1_output.c15(tmp0_desc, 10, tmp2_cached[10].f2(), value.o2z_1);
        }
        var tmp_2;
        if (tmp1_output.h15(tmp0_desc, 11)) {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$3 = emptySet();
          tmp_2 = !equals(value.p2z_1, tmp$ret$3);
        }
        if (tmp_2) {
          tmp1_output.c15(tmp0_desc, 11, tmp2_cached[11].f2(), value.p2z_1);
        }
        tmp1_output.c15(tmp0_desc, 12, tmp2_cached[12].f2(), value.q2z_1);
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !(value.r2z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 13, StringSerializer_getInstance(), value.r2z_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a4k(encoder, value instanceof Session() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v4j_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_input = decoder.l13(tmp0_desc);
        var tmp19_cached = Companion_getInstance_0().v2y_1;
        if (tmp18_input.a14()) {
          tmp4_local0 = tmp18_input.x13(tmp0_desc, 0, tmp19_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp18_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp18_input.z13(tmp0_desc, 2, tmp19_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp18_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp18_input.x13(tmp0_desc, 4, this.x4j_1, tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp18_input.x13(tmp0_desc, 5, tmp19_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp18_input.x13(tmp0_desc, 6, tmp19_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp18_input.z13(tmp0_desc, 7, tmp19_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp18_input.z13(tmp0_desc, 8, tmp19_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp18_input.z13(tmp0_desc, 9, tmp19_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp18_input.x13(tmp0_desc, 10, tmp19_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp18_input.x13(tmp0_desc, 11, tmp19_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp18_input.x13(tmp0_desc, 12, tmp19_cached[12].f2(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp18_input.z13(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp18_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp18_input.x13(tmp0_desc, 0, tmp19_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp18_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp18_input.z13(tmp0_desc, 2, tmp19_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp18_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp18_input.x13(tmp0_desc, 4, this.x4j_1, tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp18_input.x13(tmp0_desc, 5, tmp19_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp18_input.x13(tmp0_desc, 6, tmp19_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp18_input.z13(tmp0_desc, 7, tmp19_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp18_input.z13(tmp0_desc, 8, tmp19_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp18_input.z13(tmp0_desc, 9, tmp19_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp18_input.x13(tmp0_desc, 10, tmp19_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp18_input.x13(tmp0_desc, 11, tmp19_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp18_input.x13(tmp0_desc, 12, tmp19_cached[12].f2(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp18_input.z13(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp18_input.m13(tmp0_desc);
        return Session().b4k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
      }
      az() {
        return this.v4j_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_0().v2y_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), get_nullable(tmp0_cached[2].f2()), get_nullable(StringSerializer_getInstance()), this.x4j_1, tmp0_cached[5].f2(), tmp0_cached[6].f2(), get_nullable(tmp0_cached[7].f2()), get_nullable(tmp0_cached[8].f2()), get_nullable(tmp0_cached[9].f2()), tmp0_cached[10].f2(), tmp0_cached[11].f2(), tmp0_cached[12].f2(), get_nullable(StringSerializer_getInstance())];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.w4j_1, this.x4j_1];
      }
      static y4j(typeSerial0, typeSerial1) {
        var $this = this.z4j();
        $this.w4j_1 = typeSerial0;
        $this.x4j_1 = typeSerial1;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var SessionClass;
function Session() {
  if (SessionClass === VOID) {
    class $ {
      constructor(_id, secretHash, derivedFrom, label, subjectId, createdAt, lastUsed, expires, stale, terminated, ips, userAgents, scopes, oauthClient) {
        Companion_getInstance_0();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        derivedFrom = derivedFrom === VOID ? null : derivedFrom;
        label = label === VOID ? null : label;
        var tmp;
        if (createdAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = createdAt;
        }
        createdAt = tmp;
        var tmp_0;
        if (lastUsed === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance).b1m();
        } else {
          tmp_0 = lastUsed;
        }
        lastUsed = tmp_0;
        expires = expires === VOID ? null : expires;
        stale = stale === VOID ? null : stale;
        terminated = terminated === VOID ? null : terminated;
        var tmp_1;
        if (ips === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = ips;
        }
        ips = tmp_1;
        var tmp_2;
        if (userAgents === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_2 = emptySet();
        } else {
          tmp_2 = userAgents;
        }
        userAgents = tmp_2;
        oauthClient = oauthClient === VOID ? null : oauthClient;
        this.e2z_1 = _id;
        this.f2z_1 = secretHash;
        this.g2z_1 = derivedFrom;
        this.h2z_1 = label;
        this.i2z_1 = subjectId;
        this.j2z_1 = createdAt;
        this.k2z_1 = lastUsed;
        this.l2z_1 = expires;
        this.m2z_1 = stale;
        this.n2z_1 = terminated;
        this.o2z_1 = ips;
        this.p2z_1 = userAgents;
        this.q2z_1 = scopes;
        this.r2z_1 = oauthClient;
      }
      f40() {
        return this.e2z_1;
      }
      c4k(_id, secretHash, derivedFrom, label, subjectId, createdAt, lastUsed, expires, stale, terminated, ips, userAgents, scopes, oauthClient) {
        return new (Session())(_id, secretHash, derivedFrom, label, subjectId, createdAt, lastUsed, expires, stale, terminated, ips, userAgents, scopes, oauthClient);
      }
      t2z(_id, secretHash, derivedFrom, label, subjectId, createdAt, lastUsed, expires, stale, terminated, ips, userAgents, scopes, oauthClient, $super) {
        _id = _id === VOID ? this.e2z_1 : _id;
        secretHash = secretHash === VOID ? this.f2z_1 : secretHash;
        derivedFrom = derivedFrom === VOID ? this.g2z_1 : derivedFrom;
        label = label === VOID ? this.h2z_1 : label;
        subjectId = subjectId === VOID ? this.i2z_1 : subjectId;
        createdAt = createdAt === VOID ? this.j2z_1 : createdAt;
        lastUsed = lastUsed === VOID ? this.k2z_1 : lastUsed;
        expires = expires === VOID ? this.l2z_1 : expires;
        stale = stale === VOID ? this.m2z_1 : stale;
        terminated = terminated === VOID ? this.n2z_1 : terminated;
        ips = ips === VOID ? this.o2z_1 : ips;
        userAgents = userAgents === VOID ? this.p2z_1 : userAgents;
        scopes = scopes === VOID ? this.q2z_1 : scopes;
        oauthClient = oauthClient === VOID ? this.r2z_1 : oauthClient;
        return $super === VOID ? this.c4k(_id, secretHash, derivedFrom, label, subjectId, createdAt, lastUsed, expires, stale, terminated, ips, userAgents, scopes, oauthClient) : $super.c4k.call(this, _id, secretHash, derivedFrom, label, subjectId, createdAt, lastUsed, expires, stale, terminated, ips, userAgents, scopes, oauthClient);
      }
      toString() {
        return 'Session(_id=' + this.e2z_1.toString() + ', secretHash=' + this.f2z_1 + ', derivedFrom=' + toString_0(this.g2z_1) + ', label=' + this.h2z_1 + ', subjectId=' + toString(this.i2z_1) + ', createdAt=' + this.j2z_1.toString() + ', lastUsed=' + this.k2z_1.toString() + ', expires=' + toString_0(this.l2z_1) + ', stale=' + toString_0(this.m2z_1) + ', terminated=' + toString_0(this.n2z_1) + ', ips=' + toString(this.o2z_1) + ', userAgents=' + toString(this.p2z_1) + ', scopes=' + toString(this.q2z_1) + ', oauthClient=' + this.r2z_1 + ')';
      }
      hashCode() {
        var result = this.e2z_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.f2z_1) | 0;
        result = imul(result, 31) + (this.g2z_1 == null ? 0 : this.g2z_1.hashCode()) | 0;
        result = imul(result, 31) + (this.h2z_1 == null ? 0 : getStringHashCode(this.h2z_1)) | 0;
        result = imul(result, 31) + hashCode(this.i2z_1) | 0;
        result = imul(result, 31) + this.j2z_1.hashCode() | 0;
        result = imul(result, 31) + this.k2z_1.hashCode() | 0;
        result = imul(result, 31) + (this.l2z_1 == null ? 0 : this.l2z_1.hashCode()) | 0;
        result = imul(result, 31) + (this.m2z_1 == null ? 0 : this.m2z_1.hashCode()) | 0;
        result = imul(result, 31) + (this.n2z_1 == null ? 0 : this.n2z_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.o2z_1) | 0;
        result = imul(result, 31) + hashCode(this.p2z_1) | 0;
        result = imul(result, 31) + hashCode(this.q2z_1) | 0;
        result = imul(result, 31) + (this.r2z_1 == null ? 0 : getStringHashCode(this.r2z_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Session()))
          return false;
        if (!this.e2z_1.equals(other.e2z_1))
          return false;
        if (!(this.f2z_1 === other.f2z_1))
          return false;
        if (!equals(this.g2z_1, other.g2z_1))
          return false;
        if (!(this.h2z_1 == other.h2z_1))
          return false;
        if (!equals(this.i2z_1, other.i2z_1))
          return false;
        if (!this.j2z_1.equals(other.j2z_1))
          return false;
        if (!this.k2z_1.equals(other.k2z_1))
          return false;
        if (!equals(this.l2z_1, other.l2z_1))
          return false;
        if (!equals(this.m2z_1, other.m2z_1))
          return false;
        if (!equals(this.n2z_1, other.n2z_1))
          return false;
        if (!equals(this.o2z_1, other.o2z_1))
          return false;
        if (!equals(this.p2z_1, other.p2z_1))
          return false;
        if (!equals(this.q2z_1, other.q2z_1))
          return false;
        if (!(this.r2z_1 == other.r2z_1))
          return false;
        return true;
      }
      static b4k(seen0, _id, secretHash, derivedFrom, label, subjectId, createdAt, lastUsed, expires, stale, terminated, ips, userAgents, scopes, oauthClient, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(4114 === (4114 & seen0))) {
          throwMissingFieldException(seen0, 4114, Companion_getInstance_0().w2y_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.e2z_1 = Companion_getInstance().k2p();
        else
          $this.e2z_1 = _id;
        $this.f2z_1 = secretHash;
        if (0 === (seen0 & 4))
          $this.g2z_1 = null;
        else
          $this.g2z_1 = derivedFrom;
        if (0 === (seen0 & 8))
          $this.h2z_1 = null;
        else
          $this.h2z_1 = label;
        $this.i2z_1 = subjectId;
        if (0 === (seen0 & 32)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.j2z_1 = get_default(Companion_instance).b1m();
        } else
          $this.j2z_1 = createdAt;
        if (0 === (seen0 & 64)) {
          var tmp_0 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_0.k2z_1 = get_default(Companion_instance).b1m();
        } else
          $this.k2z_1 = lastUsed;
        if (0 === (seen0 & 128))
          $this.l2z_1 = null;
        else
          $this.l2z_1 = expires;
        if (0 === (seen0 & 256))
          $this.m2z_1 = null;
        else
          $this.m2z_1 = stale;
        if (0 === (seen0 & 512))
          $this.n2z_1 = null;
        else
          $this.n2z_1 = terminated;
        if (0 === (seen0 & 1024)) {
          var tmp_1 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_1.o2z_1 = emptySet();
        } else
          $this.o2z_1 = ips;
        if (0 === (seen0 & 2048)) {
          var tmp_2 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_2.p2z_1 = emptySet();
        } else
          $this.p2z_1 = userAgents;
        $this.q2z_1 = scopes;
        if (0 === (seen0 & 8192))
          $this.r2z_1 = null;
        else
          $this.r2z_1 = oauthClient;
        return $this;
      }
    }
    initMetadataForClass($, 'Session', VOID, VOID, [HasId()], VOID, VOID, {0: Companion_getInstance_0});
    SessionClass = $;
  }
  return SessionClass;
}
function IdAndAuthMethods$Companion$$childSerializers$_anonymous__wtr52c() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.a3k_1 = [null, lazy(tmp_0, IdAndAuthMethods$Companion$$childSerializers$_anonymous__wtr52c), null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.subject.IdAndAuthMethods', null, 4);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.a1b('options', true);
        tmp0_serialDesc.a1b('strengthRequired', true);
        tmp0_serialDesc.a1b('session', true);
        this.b3k_1 = tmp0_serialDesc;
      }
      c3k(typeSerial0) {
        return $serializer_0().f4k(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.c3k(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      static g4k() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.subject.IdAndAuthMethods', $this, 4);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.a1b('options', true);
        tmp0_serialDesc.a1b('strengthRequired', true);
        tmp0_serialDesc.a1b('session', true);
        $this.d4k_1 = tmp0_serialDesc;
        return $this;
      }
      h4k(encoder, value) {
        var tmp0_desc = this.d4k_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().a3k_1;
        tmp1_output.c15(tmp0_desc, 0, this.e4k_1, value.i4k_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 1)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.j4k_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.j4k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.k4k_1 === 1)) {
          tmp1_output.v14(tmp0_desc, 2, value.k4k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.l4k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.l4k_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.h4k(encoder, value instanceof IdAndAuthMethods() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d4k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_1().a3k_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, this.e4k_1, tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, tmp9_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.q13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, this.e4k_1, tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, tmp9_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.q13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return IdAndAuthMethods().m4k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.d4k_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_1().a3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.e4k_1, tmp0_cached[1].f2(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.e4k_1];
      }
      static f4k(typeSerial0) {
        var $this = this.g4k();
        $this.e4k_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var IdAndAuthMethodsClass;
function IdAndAuthMethods() {
  if (IdAndAuthMethodsClass === VOID) {
    class $ {
      toString() {
        return 'IdAndAuthMethods(id=' + toString_0(this.i4k_1) + ', options=' + toString(this.j4k_1) + ', strengthRequired=' + this.k4k_1 + ', session=' + this.l4k_1 + ')';
      }
      hashCode() {
        var result = this.i4k_1 == null ? 0 : hashCode(this.i4k_1);
        result = imul(result, 31) + hashCode(this.j4k_1) | 0;
        result = imul(result, 31) + this.k4k_1 | 0;
        result = imul(result, 31) + (this.l4k_1 == null ? 0 : getStringHashCode(this.l4k_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IdAndAuthMethods()))
          return false;
        if (!equals(this.i4k_1, other.i4k_1))
          return false;
        if (!equals(this.j4k_1, other.j4k_1))
          return false;
        if (!(this.k4k_1 === other.k4k_1))
          return false;
        if (!(this.l4k_1 == other.l4k_1))
          return false;
        return true;
      }
      static m4k(seen0, id, options, strengthRequired, session, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance_1().b3k_1);
        }
        var $this = createThis(this);
        $this.i4k_1 = id;
        if (0 === (seen0 & 2)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.j4k_1 = emptyList();
        } else
          $this.j4k_1 = options;
        if (0 === (seen0 & 4))
          $this.k4k_1 = 1;
        else
          $this.k4k_1 = strengthRequired;
        if (0 === (seen0 & 8))
          $this.l4k_1 = null;
        else
          $this.l4k_1 = session;
        return $this;
      }
    }
    initMetadataForClass($, 'IdAndAuthMethods', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    IdAndAuthMethodsClass = $;
  }
  return IdAndAuthMethodsClass;
}
function LogInRequest$Companion$$childSerializers$_anonymous__8nyk64() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
function LogInRequest$Companion$$childSerializers$_anonymous__8nyk64_0() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
function LogInRequest$Companion$$childSerializers$_anonymous__8nyk64_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LogInRequest$Companion$$childSerializers$_anonymous__8nyk64);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, LogInRequest$Companion$$childSerializers$_anonymous__8nyk64_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.z3j_1 = [tmp_1, null, tmp_3, lazy(tmp_4, LogInRequest$Companion$$childSerializers$_anonymous__8nyk64_1)];
      }
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new (Companion_1())();
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.subject.LogInRequest', this, 4);
        tmp0_serialDesc.a1b('proofs', false);
        tmp0_serialDesc.a1b('label', true);
        tmp0_serialDesc.a1b('scopes', true);
        tmp0_serialDesc.a1b('expires', true);
        this.n4k_1 = tmp0_serialDesc;
      }
      o4k(encoder, value) {
        var tmp0_desc = this.n4k_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().z3j_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.p4k_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.q4k_1 === 'Root Session')) {
          tmp1_output.a15(tmp0_desc, 1, value.q4k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !equals(value.r4k_1, setOf('*'))) {
          tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.r4k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.s4k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.s4k_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o4k(encoder, value instanceof LogInRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n4k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_2().z3j_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return LogInRequest().t4k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.n4k_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_2().z3j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), tmp0_cached[2].f2(), get_nullable(tmp0_cached[3].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance;
function $serializer_getInstance_1() {
  if ($serializer_instance === VOID)
    new ($serializer_1())();
  return $serializer_instance;
}
var LogInRequestClass;
function LogInRequest() {
  if (LogInRequestClass === VOID) {
    class $ {
      toString() {
        return 'LogInRequest(proofs=' + toString(this.p4k_1) + ', label=' + this.q4k_1 + ', scopes=' + toString(this.r4k_1) + ', expires=' + toString_0(this.s4k_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.p4k_1);
        result = imul(result, 31) + getStringHashCode(this.q4k_1) | 0;
        result = imul(result, 31) + hashCode(this.r4k_1) | 0;
        result = imul(result, 31) + (this.s4k_1 == null ? 0 : this.s4k_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LogInRequest()))
          return false;
        if (!equals(this.p4k_1, other.p4k_1))
          return false;
        if (!(this.q4k_1 === other.q4k_1))
          return false;
        if (!equals(this.r4k_1, other.r4k_1))
          return false;
        if (!equals(this.s4k_1, other.s4k_1))
          return false;
        return true;
      }
      static t4k(seen0, proofs, label, scopes, expires, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().n4k_1);
        }
        var $this = createThis(this);
        $this.p4k_1 = proofs;
        if (0 === (seen0 & 2))
          $this.q4k_1 = 'Root Session';
        else
          $this.q4k_1 = label;
        if (0 === (seen0 & 4))
          $this.r4k_1 = setOf('*');
        else
          $this.r4k_1 = scopes;
        if (0 === (seen0 & 8))
          $this.s4k_1 = null;
        else
          $this.s4k_1 = expires;
        return $this;
      }
    }
    initMetadataForClass($, 'LogInRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    LogInRequestClass = $;
  }
  return LogInRequestClass;
}
function ProofsCheckResult$Companion$$childSerializers$_anonymous__gqv6ms() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function ProofsCheckResult$Companion$$childSerializers$_anonymous__gqv6ms_0() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProofsCheckResult$Companion$$childSerializers$_anonymous__gqv6ms);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d3k_1 = [null, tmp_1, null, null, lazy(tmp_2, ProofsCheckResult$Companion$$childSerializers$_anonymous__gqv6ms_0)];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.subject.ProofsCheckResult', null, 5);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.a1b('options', true);
        tmp0_serialDesc.a1b('strengthRequired', true);
        tmp0_serialDesc.a1b('readyToLogIn', false);
        tmp0_serialDesc.a1b('maxExpiration', false);
        this.e3k_1 = tmp0_serialDesc;
      }
      c3k(typeSerial0) {
        return $serializer_2().w4k(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.c3k(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new (Companion_2())();
  return Companion_instance_3;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      static x4k() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.subject.ProofsCheckResult', $this, 5);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.a1b('options', true);
        tmp0_serialDesc.a1b('strengthRequired', true);
        tmp0_serialDesc.a1b('readyToLogIn', false);
        tmp0_serialDesc.a1b('maxExpiration', false);
        $this.u4k_1 = tmp0_serialDesc;
        return $this;
      }
      y4k(encoder, value) {
        var tmp0_desc = this.u4k_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().d3k_1;
        tmp1_output.c15(tmp0_desc, 0, this.v4k_1, value.z4k_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 1)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.a4l_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.a4l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.b4l_1 === 1)) {
          tmp1_output.v14(tmp0_desc, 2, value.b4l_1);
        }
        tmp1_output.s14(tmp0_desc, 3, value.c4l_1);
        tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.d4l_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y4k(encoder, value instanceof ProofsCheckResult() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.u4k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_3().d3k_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, this.v4k_1, tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, tmp10_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.q13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, this.v4k_1, tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, tmp10_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.q13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return ProofsCheckResult().e4l(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.u4k_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_3().d3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.v4k_1, tmp0_cached[1].f2(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[4].f2())];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.v4k_1];
      }
      static w4k(typeSerial0) {
        var $this = this.x4k();
        $this.v4k_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var ProofsCheckResultClass;
function ProofsCheckResult() {
  if (ProofsCheckResultClass === VOID) {
    class $ {
      toString() {
        return 'ProofsCheckResult(id=' + toString_0(this.z4k_1) + ', options=' + toString(this.a4l_1) + ', strengthRequired=' + this.b4l_1 + ', readyToLogIn=' + this.c4l_1 + ', maxExpiration=' + toString_0(this.d4l_1) + ')';
      }
      hashCode() {
        var result = this.z4k_1 == null ? 0 : hashCode(this.z4k_1);
        result = imul(result, 31) + hashCode(this.a4l_1) | 0;
        result = imul(result, 31) + this.b4l_1 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.c4l_1) | 0;
        result = imul(result, 31) + (this.d4l_1 == null ? 0 : this.d4l_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProofsCheckResult()))
          return false;
        if (!equals(this.z4k_1, other.z4k_1))
          return false;
        if (!equals(this.a4l_1, other.a4l_1))
          return false;
        if (!(this.b4l_1 === other.b4l_1))
          return false;
        if (!(this.c4l_1 === other.c4l_1))
          return false;
        if (!equals(this.d4l_1, other.d4l_1))
          return false;
        return true;
      }
      static e4l(seen0, id, options, strengthRequired, readyToLogIn, maxExpiration, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(25 === (25 & seen0))) {
          throwMissingFieldException(seen0, 25, Companion_getInstance_3().e3k_1);
        }
        var $this = createThis(this);
        $this.z4k_1 = id;
        if (0 === (seen0 & 2)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.a4l_1 = emptyList();
        } else
          $this.a4l_1 = options;
        if (0 === (seen0 & 4))
          $this.b4l_1 = 1;
        else
          $this.b4l_1 = strengthRequired;
        $this.c4l_1 = readyToLogIn;
        $this.d4l_1 = maxExpiration;
        return $this;
      }
    }
    initMetadataForClass($, 'ProofsCheckResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    ProofsCheckResultClass = $;
  }
  return ProofsCheckResultClass;
}
function SubSessionRequest$Companion$$childSerializers$_anonymous__jlvzld() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
function SubSessionRequest$Companion$$childSerializers$_anonymous__jlvzld_0() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, SubSessionRequest$Companion$$childSerializers$_anonymous__jlvzld);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.x3j_1 = [null, tmp_1, null, lazy(tmp_2, SubSessionRequest$Companion$$childSerializers$_anonymous__jlvzld_0)];
      }
      k2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new (Companion_3())();
  return Companion_instance_4;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.subject.SubSessionRequest', this, 4);
        tmp0_serialDesc.a1b('label', false);
        tmp0_serialDesc.a1b('scopes', true);
        tmp0_serialDesc.a1b('oauthClient', true);
        tmp0_serialDesc.a1b('expires', true);
        this.f4l_1 = tmp0_serialDesc;
      }
      g4l(encoder, value) {
        var tmp0_desc = this.f4l_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_4().x3j_1;
        tmp1_output.a15(tmp0_desc, 0, value.h4l_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !equals(value.i4l_1, setOf('*'))) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.i4l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.j4l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, StringSerializer_getInstance(), value.j4l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.k4l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.k4l_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g4l(encoder, value instanceof SubSessionRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f4l_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_4().x3j_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, tmp9_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, tmp9_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return SubSessionRequest().l4l(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.f4l_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_4().x3j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_0;
function $serializer_getInstance_2() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_3())();
  return $serializer_instance_0;
}
var SubSessionRequestClass;
function SubSessionRequest() {
  if (SubSessionRequestClass === VOID) {
    class $ {
      toString() {
        return 'SubSessionRequest(label=' + this.h4l_1 + ', scopes=' + toString(this.i4l_1) + ', oauthClient=' + this.j4l_1 + ', expires=' + toString_0(this.k4l_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.h4l_1);
        result = imul(result, 31) + hashCode(this.i4l_1) | 0;
        result = imul(result, 31) + (this.j4l_1 == null ? 0 : getStringHashCode(this.j4l_1)) | 0;
        result = imul(result, 31) + (this.k4l_1 == null ? 0 : this.k4l_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SubSessionRequest()))
          return false;
        if (!(this.h4l_1 === other.h4l_1))
          return false;
        if (!equals(this.i4l_1, other.i4l_1))
          return false;
        if (!(this.j4l_1 == other.j4l_1))
          return false;
        if (!equals(this.k4l_1, other.k4l_1))
          return false;
        return true;
      }
      static l4l(seen0, label, scopes, oauthClient, expires, serializationConstructorMarker) {
        Companion_getInstance_4();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_2().f4l_1);
        }
        var $this = createThis(this);
        $this.h4l_1 = label;
        if (0 === (seen0 & 2))
          $this.i4l_1 = setOf('*');
        else
          $this.i4l_1 = scopes;
        if (0 === (seen0 & 4))
          $this.j4l_1 = null;
        else
          $this.j4l_1 = oauthClient;
        if (0 === (seen0 & 8))
          $this.k4l_1 = null;
        else
          $this.k4l_1 = expires;
        return $this;
      }
    }
    initMetadataForClass($, 'SubSessionRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    SubSessionRequestClass = $;
  }
  return SubSessionRequestClass;
}
//region block: exports
export {
  Session as Sessionjhz9dr2n4d55,
  Companion_getInstance_1 as Companion_getInstance2bk062dpuj8t4,
  Companion_getInstance_2 as Companion_getInstancedici4y8vd124,
  Companion_getInstance_3 as Companion_getInstance3332ape10v2ob,
  Companion_getInstance_0 as Companion_getInstance1dz3q9fvss53i,
  Companion_getInstance_4 as Companion_getInstance2pteqjzccrqe9,
};
//endregion

//# sourceMappingURL=subjectModels.mjs.map
